import gql from "graphql-tag";
// Login user
export const SEND_CONTACT_FORM_MUTATION = gql`
  mutation sendContactForm($user_name: String!, $email: String!, $topic: String!, $message: String!) {
    sendContactForm(user_name: $user_name, email: $email, topic: $topic, message: $message) {
			email
		}
  }
`;